import { ArrowLeft } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Seo } from '../lib/seo';

export function NotFoundPage() {
  const location = useLocation();
  return <section className="not-found"><Seo title="Page Not Found" description="The requested Nexhance AI page could not be found." path={location.pathname} noindex /><div><p className="eyebrow">404</p><h1>This page is out of focus.</h1><p>The route does not exist or may have moved.</p><Link className="button button-primary" to="/"><ArrowLeft size={17} /> Back home</Link></div></section>;
}
